export default {
    when() {
        return $('.accordeon').length > 0;
    },

    mounted() {
        $('.accordeon').click(function() {
            const isOpen = $(this).hasClass('open');

            $('.accordeon').removeClass('open');

            if (!isOpen) {
                $(this).addClass('open');
            }
        });
    },
};
